import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { faDoorOpen, faFire } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import confirmButton from '../../assets/audio/UI_Metal_2.wav';
import navigateButton from '../../assets/audio/UI_Select_2.wav';
import { Button, Flex, Progress, Space, Typography } from 'antd';
import { FC, useCallback } from 'react';
import { Link } from 'react-router-dom';

import { useGameStore, useOptionsStore } from '../store/game.store';

interface OptionsPageProps extends React.PropsWithChildren { }
const WarScholarOptionsProps: FC<OptionsPageProps> = () => {
   const { gameActions } = useGameStore();

   const { state: optionsState, actions: optionsActions } = useOptionsStore();

   const handleReset = useCallback(() => {
      new Audio(confirmButton).play();
      gameActions.resetState();
   }, [gameActions]);

   const playNavigationSound = () => {
      new Audio(navigateButton).play();
   };

   const increaseMusic = useCallback(() => {
      let newPercent = optionsState.backgroundMusicTrackVolume + 0.1;
      if (newPercent > 1) {
         newPercent = 1;
      }
      optionsActions.setBackgroundMusicTrackVolume({ volume: newPercent });
   }, [optionsActions, optionsState.backgroundMusicTrackVolume]);

   const decreaseMusic = useCallback(() => {
      new Audio(confirmButton).play();
      let newPercent = optionsState.backgroundMusicTrackVolume - 0.1;
      if (newPercent < 0) {
         newPercent = 0;
      }
      optionsActions.setBackgroundMusicTrackVolume({ volume: newPercent });
   }, [optionsActions, optionsState.backgroundMusicTrackVolume]);

   return (
      <div className="flex-1 flex flex-col p-2">
         <Typography.Title>Options</Typography.Title>
         <Space size="large">
            <Link to="/warscholar">
               <button onClick={playNavigationSound}>
                  <FontAwesomeIcon icon={faDoorOpen} /> Back
               </button>
            </Link>
         </Space>
         <Space>
            <p>Music Volume</p>

            <Flex
               gap="small"
               style={{ width: 180 }}
            >
               <Button
                  onClick={decreaseMusic}
                  icon={<MinusOutlined />}
               />
               <Progress
                  percent={optionsState.backgroundMusicTrackVolume * 100}
                  type="line"
                  format={(percent) => `${percent!.toFixed(0)} %`}
               />
               <Button
                  onClick={increaseMusic}
                  icon={<PlusOutlined />}
               />
            </Flex>
         </Space>

         <Space>
            <p>Reset all progress</p>
            <Button
               danger
               type="primary"
               onClick={handleReset}
               icon={
                  <FontAwesomeIcon
                     icon={faFire}
                     className="text-white"
                  />
               }
            >
               reset!
            </Button>
         </Space>

      </div>
   );
};

export const WarScholarOptionsPage = WarScholarOptionsProps;


